export { default } from '@/features/pulse/PulseScreen';
